module.exports = __webpack_public_path__ + "img/12blue-2024.19657f00.png";